import { UserRole } from '@jalupro/shared';
import { AGENT_NAV, navForRole } from '../components';
import { useRoleLabel } from '../i18n';
import { PortalLayout } from './PortalLayout';

/** Agent portal shell (/agent/*) — CleanSidebar with the agent nav. */
export function AgentLayout() {
  const roleLabel = useRoleLabel();
  return <PortalLayout items={navForRole(AGENT_NAV, UserRole.AGENT)} brandLabel="Agent portal" roleLabel={roleLabel(UserRole.AGENT)} />;
}
